// Theme: tokyo-night
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'tokyo-night',
  name: 'TOKYO NIGHT',
  tagline: 'TOKYO NIGHT',
  description: 'Noites de Toquio. Azul-indigo suave sobre escuridao urbana fria.',
  category: 'neon-cyber',
  tier: 'rare',
  basePrice: 1200,
  swatches: ['#1A1B26', '#7AA2F7', '#24283B', '#C0CAF5'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '2px',
      '--radius': '4px',
      '--shadow-card': '0 14px 36px rgba(122, 162, 247, 0.08)',
      '--shadow-card-active': '0 14px 36px rgba(122, 162, 247, 0.08)'
    },
    shellClasses: 'font-mono theme-tokyo-night'
  },
  colorVars: {
    '--accent': '#7AA2F7',
    '--accent-foreground': '#1A1B26',
    '--background': '#1A1B26',
    '--border': '#565F89',
    '--card': '#24283B',
    '--card-border-active': 'rgba(122, 162, 247, 0.08)',
    '--card-completed': '#2A3044',
    '--card-foreground': '#C0CAF5',
    '--card-glow': 'rgba(122, 162, 247, 0.08)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#1A1B26',
    '--foreground': '#C0CAF5',
    '--hold-fill': '#7AA2F7',
    '--input': '#24283B',
    '--modal-bg': '#1A1B26',
    '--modal-border': '#565F89',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 14px 36px rgba(122, 162, 247, 0.08)',
    '--muted': '#24283B',
    '--muted-foreground': '#A4B3E7',
    '--nav-active': '#7AA2F7',
    '--nav-bg': '#1A1B26',
    '--popover': '#24283B',
    '--popover-foreground': '#C0CAF5',
    '--primary': '#7AA2F7',
    '--primary-foreground': '#1A1B26',
    '--ring': '#7AA2F7',
    '--secondary': '#565F89',
    '--secondary-foreground': '#C0CAF5',
    '--streak': '#7AA2F7',
    '--success': '#22c55e',
    '--success-foreground': '#1A1B26',
    '--xp': '#7AA2F7',
    '--xp-bg': '#24283B'
  },
  resolvedVars: {
    '--accent': '#7AA2F7',
    '--accent-foreground': '#1A1B26',
    '--accent-foreground-hsl': '235 19% 13%',
    '--accent-foreground-oklch': 'from #1A1B26 l c h',
    '--accent-hsl': '221 89% 72%',
    '--accent-oklch': 'from #7AA2F7 l c h',
    '--background': '#1A1B26',
    '--background-hsl': '235 19% 13%',
    '--background-oklch': 'from #1A1B26 l c h',
    '--border': '#565F89',
    '--border-hsl': '229 23% 44%',
    '--border-oklch': 'from #565F89 l c h',
    '--border-w': '2px',
    '--card': '#24283B',
    '--card-border-active': 'rgba(122, 162, 247, 0.08)',
    '--card-completed': '#2A3044',
    '--card-completed-hsl': '226 24% 22%',
    '--card-completed-oklch': 'from #2A3044 l c h',
    '--card-foreground': '#C0CAF5',
    '--card-foreground-hsl': '229 73% 86%',
    '--card-foreground-oklch': 'from #C0CAF5 l c h',
    '--card-glow': 'rgba(122, 162, 247, 0.08)',
    '--card-hsl': '230 24% 19%',
    '--card-oklch': 'from #24283B l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#1A1B26',
    '--destructive-foreground-hsl': '235 19% 13%',
    '--destructive-foreground-oklch': 'from #1A1B26 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#C0CAF5',
    '--foreground-hsl': '229 73% 86%',
    '--foreground-oklch': 'from #C0CAF5 l c h',
    '--hold-fill': '#7AA2F7',
    '--hold-fill-hsl': '221 89% 72%',
    '--hold-fill-oklch': 'from #7AA2F7 l c h',
    '--input': '#24283B',
    '--input-hsl': '230 24% 19%',
    '--input-oklch': 'from #24283B l c h',
    '--modal-bg': '#1A1B26',
    '--modal-bg-hsl': '235 19% 13%',
    '--modal-bg-oklch': 'from #1A1B26 l c h',
    '--modal-border': '#565F89',
    '--modal-border-hsl': '229 23% 44%',
    '--modal-border-oklch': 'from #565F89 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 14px 36px rgba(122, 162, 247, 0.08)',
    '--muted': '#24283B',
    '--muted-foreground': '#A4B3E7',
    '--muted-foreground-hsl': '227 58% 77%',
    '--muted-foreground-oklch': 'from #A4B3E7 l c h',
    '--muted-hsl': '230 24% 19%',
    '--muted-oklch': 'from #24283B l c h',
    '--nav-active': '#7AA2F7',
    '--nav-active-hsl': '221 89% 72%',
    '--nav-active-oklch': 'from #7AA2F7 l c h',
    '--nav-bg': '#1A1B26',
    '--nav-bg-hsl': '235 19% 13%',
    '--nav-bg-oklch': 'from #1A1B26 l c h',
    '--popover': '#24283B',
    '--popover-foreground': '#C0CAF5',
    '--popover-foreground-hsl': '229 73% 86%',
    '--popover-foreground-oklch': 'from #C0CAF5 l c h',
    '--popover-hsl': '230 24% 19%',
    '--popover-oklch': 'from #24283B l c h',
    '--primary': '#7AA2F7',
    '--primary-foreground': '#1A1B26',
    '--primary-foreground-hsl': '235 19% 13%',
    '--primary-foreground-oklch': 'from #1A1B26 l c h',
    '--primary-hsl': '221 89% 72%',
    '--primary-oklch': 'from #7AA2F7 l c h',
    '--radius': '4px',
    '--ring': '#7AA2F7',
    '--ring-hsl': '221 89% 72%',
    '--ring-oklch': 'from #7AA2F7 l c h',
    '--secondary': '#565F89',
    '--secondary-foreground': '#C0CAF5',
    '--secondary-foreground-hsl': '229 73% 86%',
    '--secondary-foreground-oklch': 'from #C0CAF5 l c h',
    '--secondary-hsl': '229 23% 44%',
    '--secondary-oklch': 'from #565F89 l c h',
    '--shadow-card': '0 14px 36px rgba(122, 162, 247, 0.08)',
    '--shadow-card-active': '0 14px 36px rgba(122, 162, 247, 0.08)',
    '--streak': '#7AA2F7',
    '--streak-hsl': '221 89% 72%',
    '--streak-oklch': 'from #7AA2F7 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#1A1B26',
    '--success-foreground-hsl': '235 19% 13%',
    '--success-foreground-oklch': 'from #1A1B26 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(221 89% 72% / 0.15)',
    '--xp': '#7AA2F7',
    '--xp-bg': '#24283B',
    '--xp-bg-hsl': '230 24% 19%',
    '--xp-bg-oklch': 'from #24283B l c h',
    '--xp-hsl': '221 89% 72%',
    '--xp-oklch': 'from #7AA2F7 l c h'
  }
}
